import Model from '@/models/Model'

export default class ABarAuthorization extends Model {
    /**
     *
     */
    resource() {
        return 'bar_authorization'
    }
}
